"use client";
import React from "react";
import { ElementHighlighter } from "../../ElementHighlighter";
import { ElementTagLabel } from "../ElementTagLabel";

interface SelectedElementsProps {
  selectedElements: HTMLElement[];
  elementLabel?: (element: HTMLElement) => React.ReactNode;
  highlighterStyle?: React.CSSProperties;
}

export const SelectedElements: React.FC<SelectedElementsProps> = ({
  selectedElements,
  elementLabel,
  highlighterStyle,
}) => {
  return (
    <>
      {selectedElements.map((element, index) => {
        // Add data attribute to mark as selected for tracking
        element.setAttribute("data-element-inspector-selected", "true");
        return (
          <ElementHighlighter
            key={`selected-${index}`}
            element={element}
            borderColor="rgba(34, 197, 94, 0.8)" // Green border
            // backgroundColor="rgba(34, 197, 94, 0.2)" // Light green background
            style={highlighterStyle}
          >
            {elementLabel ? (
              elementLabel(element)
            ) : (
              <ElementTagLabel element={element} />
            )}
          </ElementHighlighter>
        );
      })}
    </>
  );
};
